import axios from 'axios';
import Mixpanel from '../utils/mixpanel-helper.js';

export const CHECK_NPS_PENDING = 'NPS/CHECK_PENDING';
export const CHECK_NPS_SUCCESS = 'NPS/CHECK_SUCCESS';
export const SUBMIT_NPS_SUCCESS = 'NPS/SUBMIT_SUCCESS';
export const DISMISS_NPS = 'NPS/DISMISS';
export const NPS_ERROR = 'NPS/ERROR';

export function checkPendingNPS(token) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/api/nps/pending/', {
        headers: { Authorization: `Token ${token}` }
      });
      dispatch({ type: CHECK_NPS_SUCCESS, payload: response.data });
    } catch (err) {
      dispatch({ type: NPS_ERROR });
    }
  };
}

export function submitNPS(token, data, successCallback) {
  return async (dispatch) => {
    try {
      await axios.post('/api/nps/submit/', data, {
        headers: { Authorization: `Token ${token}` }
      });
      Mixpanel.track('NPS survey submitted', {
        checkpoint: data.checkpoint,
        nps_score: data.nps_score
      });
      dispatch({ type: SUBMIT_NPS_SUCCESS });
      if (successCallback) successCallback();
    } catch (err) {
      dispatch({ type: NPS_ERROR });
    }
  };
}

export function dismissNPS(token, data) {
  return async (dispatch) => {
    try {
      await axios.post('/api/nps/dismiss/', data, {
        headers: { Authorization: `Token ${token}` }
      });
      Mixpanel.track('NPS survey dismissed', { checkpoint: data.checkpoint });
      dispatch({ type: DISMISS_NPS });
    } catch (err) {
      // Silent fail for dismiss
    }
  };
}
